import { useEffect } from 'react';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';

// Listens to agent conversation messages for a given agent conversation id
// Filters messages to the current conversation, updates state, and caches
export const useAgentConversationListener = ({
  db,
  user,
  conversation,
  firestoreConvId,
  localFirestoreConvId,
  dispatch,
  chatCache,
  offlineStorage
}) => {
  useEffect(() => {
    if (!user || !conversation || conversation.id !== 'admin') return;

    const convId = firestoreConvId || localFirestoreConvId;
    if (!convId) return;

    // Set up real-time listener for agent conversation messages
    const messagesCol = collection(db, 'agentConversations', convId, 'messages');
    const q = query(messagesCol, orderBy('timestamp', 'asc'));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const msgs = snapshot.docs.map(docSnapshot => {
        const data = docSnapshot.data();
        return {
          id: docSnapshot.id,
          ...data,
          time: data.timestamp ? new Date(data.timestamp.toDate()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        };
      });

      // Ensure message belongs to current conversation
      const filteredMsgs = msgs.filter(msg => msg.conversationId === convId || !msg.conversationId);

      dispatch({ type: 'SET_FIRESTORE_MESSAGES', payload: filteredMsgs });

      // Cache messages for offline access
      try {
        if (chatCache) chatCache.cacheMessages(convId, filteredMsgs);
        if (offlineStorage) offlineStorage.cacheMessages(convId, filteredMsgs);
      } catch (error) {
        // ignore cache errors
      }
    }, () => {});

    return () => {
      unsubscribe();
    };
  }, [db, user, conversation, firestoreConvId, localFirestoreConvId, dispatch, chatCache, offlineStorage]);
};

export default useAgentConversationListener;


